export function createKey() {
  const key = (Date.now() + '-' + Math.ceil(Math.random() * 99999));
  return key;
}